// extracted by mini-css-extract-plugin
module.exports = {"section":"downloads-module--section--2rntk"};